
angular.module('jv.changeStatus.controller', [])
    .controller('jvChangeStatusController', [
        '$scope', '$rootScope','TemplateLoader','jvCandidatesService','jvHireBroadcastSVC',
        function($scope, $rootScope,TemplateLoader,jvCandidatesService,jvHireBroadcastSVC) {

            $scope.initData = function() {
                $scope.changeStatusObject = undefined;
            };

            jvHireBroadcastSVC.subscribe('hidingCandidateModals', function() {
                $scope.initData();
                $rootScope.$broadcast('showChangeStatusResult', false);
            });

            $scope.init = function() {
            	$scope.initData();
                $scope.flags.loading = true;
                
                var postData = {
            			data: $scope.modalData.appIds,
            			action: 'changeStatus'
            	};

                jvCandidatesService.validateCandidateDetails(postData, function(res) {
                	if (res.status !== 200 || !res.data) {
                		$scope.flags.loading = false;
                		return;
                	}

                	if(res.data.validApplicationIds.length === 0) {
                		var actionValidation = {};
                		actionValidation.show = true;
                		actionValidation.title = i18n.MODULES_CANDIDATES_MODALS_CHANGESTATUS_CHANGE_STATUS;
                		actionValidation.message = i18n.CANDIDATES_CHANGE_STATUS_PERMISSION_MSG;
                		$rootScope.$emit('actionValidation', actionValidation);
                		return;
                	}
                	$scope.modalData.validationResult = res.data;
                	$scope.modalData.appIds = $scope.modalData.validationResult.validApplicationIds;

                	var actionFn = 'getChangeStatus';
                	var postData = {
                			reqId: $scope.modalData.reqId
                	};

                	if(window.disableFlags && !window.disableFlags.skipWorkflow){
                		if($scope.modalData.displayCurrentStatus) {
                			postData.currentStatus = $scope.modalData.displayCurrentStatus;
                			actionFn = 'getNextStatusChange';
                		}
                	}

                	jvCandidatesService[actionFn](postData, function(response) {
                		$scope.flags.loading = false;
                		if (response && response.status !== 200 && angular.isDefined(response.data)) {
                			return;
                		}
                		$scope.modals.changeStatus = true;
                		$scope.statuses = response.data.candidateWorkFlowStates;
                		if ($scope.modalData.displayCurrentStatus) {
                			$scope.changeStatusObject = $scope.statuses.filter(function(status) {
                				return (status.EId === $scope.modalData.displayCurrentStatus);
                			}).pop();
                		}
                	});
                });
            };

            jvHireBroadcastSVC.subscribe('VIDEO_CLEAR_SCOPE', function() {
                $scope.hideModals();
                $scope.initData();
            });

            jvHireBroadcastSVC.subscribe('showChangeStatusModalView', function() {
                $scope.init();
            });

            jvHireBroadcastSVC.subscribe('postChangeStatus', function(event, postObject) {
                if (postObject) {
                    delete postObject.skipModalView;
                    $scope.changeStatusObject = postObject;
                    $scope.changeStatus();
                }
            });

            $scope.changeStatus = function() {
                if (angular.isUndefined($scope.changeStatusObject)) {
                    return;
                }
                switch($scope.changeStatusObject.predefinedKind){
                    case 'SUBMITTED_TO_HIRING_MANAGER':
                        //hiding change status modal
                        $scope.hideModals();
                        var submitToHiringManagerObject = {};
                        submitToHiringManagerObject.appIds = $scope.modalData.appIds;
                        submitToHiringManagerObject.name = $scope.modalData.name;
                        submitToHiringManagerObject.stateId = $scope.changeStatusObject.EId;
                        if(JV.Person){
                            submitToHiringManagerObject.jobEId = JV.Person.getUniqueSelectedApplicationJobIds()[0];
                        }else{
                            submitToHiringManagerObject.jobEId = $scope.modalData.reqId
                        }
                        $rootScope.$broadcast('SUBMIT_HM_MODAL_CLICKED', submitToHiringManagerObject);
                        break;
                    default:
                        if($scope.changeStatusObject.kind === 'VIDEO_SCREEN'){
                            var sendVideoObject = {};
                            sendVideoObject.appIds = $scope.modalData.appIds;
                            sendVideoObject.name = $scope.modalData.name;
                            // adding addtional three parameters for workflow.
                            sendVideoObject.stateId = $scope.changeStatusObject.EId;
                            sendVideoObject.workflowStateKind = $scope.changeStatusObject.kind;
                            sendVideoObject.workflowStateName = $scope.changeStatusObject.name;
                            if($scope.modalData && $scope.modalData.reqId){
                                sendVideoObject.jobEId = $scope.modalData.reqId;
                            }else{
                                sendVideoObject.jobEId = JV.Person.getUniqueSelectedApplicationJobIds()[0];
                            }
                            $scope.hideModals();
                            $rootScope.$broadcast('showVideoModalForWorkflow',sendVideoObject);
                            //Fix for HIRE-11012 . If candidate has no email show error modal
//                            $rootScope.$broadcast('showVideoModalAdHoc',sendVideoObject);
                        }else{
                            var changeStatusForm = {};
                            changeStatusForm.appIds = $scope.modalData.appIds;
                            changeStatusForm.workflowStateName = $scope.changeStatusObject.name;
                            $scope.flags.loading = true;
                            jvCandidatesService.changeStatus(changeStatusForm, function(response) {
                                $scope.flags.loading = false;
                                //WIP: Once Harsh is ready with BE, will need to add more code here.
                                if (response && response.status && response.status.statusCode === 200) {
                                    //appId is used to re-open the quickview to show the new status while changing status within quickview from details page.
                                    $rootScope.$broadcast('showChangeStatusResult', true, $scope.applicationId);
                                } else {
                                    $rootScope.$broadcast('showChangeStatusResult', false);
                                }
                                $scope.hideModals();
                                $scope.initData();
                            });

                        }
                        break;
                }
            };
        }
]);